module.exports = __webpack_public_path__ + "img/r4.64dfdc7d.png";